angular
  .module('app')
  .factory('user', user);

function user(Restangular) {
  return Restangular.service('AcbRegistration');
}